module.exports = __webpack_public_path__ + "src/assets/img/szst_sd_02@2x.3bd6e015.png";